import * as commonSvgIcons from '@am/common-svg-icons';

// Custom icons hotels
import { SvgIconDefinition } from '@am/icons-common-types';

export const hotelsIcons = [...(Object.values(commonSvgIcons) as SvgIconDefinition[])];
